import fly from '@/api/fly'

export const fetchCancelOrder = (params: Object) =>
  fly.get('/mall/cs/order/cancel.json', params)
